import React, { useState, useEffect } from 'react';

// consts and libs
import Translation from 'libs/Translation';

const _formatTimer = initialSeconds => {
	let minutes = Math.floor(initialSeconds / 60);
	let seconds = initialSeconds % 60;

	if (minutes < 10) minutes = `0${minutes}`;
	if (seconds < 10) seconds = `0${seconds}`;

	return Translation.n(`${minutes}:${seconds}`);
};

const Timer = props => {
	const { initialSeconds, onFinishTimer, color } = props;

	const [seconds, setSeconds] = useState(initialSeconds);

	useEffect(() => {
		let interval;
		if (seconds > 0) {
			if (!interval) {
				interval = setInterval(() => {
					setSeconds(s => s - 1);
				}, 1000);
			}
		}
		
		else if (onFinishTimer) {
			onFinishTimer();
		}
		return () => clearInterval(interval);
	});

	return (
		<span 
            style={{
                color: color ?? '#61788E',
                fontSize: 14,
                fontWeight: '700'
            }}
        >
            {_formatTimer(seconds)}
        </span>
	)
};


export default Timer;